import Vue from "vue";
import zn from "./zn";
import en from "./en";
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 全局注册国际化包
var currentUrl = window.location.href;
var hashIndex = currentUrl.indexOf("?");
var hash = hashIndex !== -1 ? currentUrl.substring(hashIndex + 1) : "";
var urlParams = new URLSearchParams(hash);
let lang = urlParams.get("lang");
let current = localStorage.getItem("lang")
  ? localStorage.getItem("lang")
  : "zn";
if (lang === "EN") {
  current = "en";
  localStorage.setItem("lang", "en");
} else if (lang === "CN") {
  current = "zn";
  localStorage.setItem("lang", "zn");
}
// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: current, // 初始化中文
  messages: {
    zn: zn,
    en: en,
  },
});

export default i18n;
